import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Grid, Paper, Typography, Box, Divider } from '@material-ui/core'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../classes/Styles'
import LinearProgress from '@material-ui/core/LinearProgress'
import * as _ from 'lodash'

import { GLOBAL_ATTENTION_INDEX_3 } from '../../constants/colors'
import Table from '@material-ui/core/Table'
import TablePagination from '@material-ui/core/TablePagination'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import { GENRE_MAPPINGS } from '../../constants/labels'
import { TableFormats } from '../TableHelpers'

const BorderLinearProgressPrimary = withStyles((theme) => ({
  root: {
    height: 16,
    borderRadius: 0
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700]
  },
  bar: {
    borderRadius: 0,
    backgroundColor: GLOBAL_ATTENTION_INDEX_3
  }
}))(LinearProgress)

export class GlobalAttentionGenreComponent extends Component {
  static propTypes = {
    screenWidth: PropTypes.number,
    classes: PropTypes.object.isRequired,
    attentionIndexDetails: PropTypes.object,
    setSelectedGenres: PropTypes.func,
    selectedGenres: PropTypes.array
  }

  constructor (props) {
    super(props)

    this.state = {
      primaryNetworkByDistributor: null,
      page: 0,
      rowsPerPage: 3,
      genreList: null
    }
  }

  componentDidMount () {
    if (this.props.attentionIndexDetails) {
      this.setGenreListByEngagement()
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.attentionIndexDetails !== this.props.attentionIndexDetails) {
      this.setState({
        page: 0
      })
      this.setGenreListByEngagement()
    }
  }

  setGenreListByEngagement = () => {
    const details = this.props.attentionIndexDetails && this.props.attentionIndexDetails.details ? this.props.attentionIndexDetails.details : []
    let genreList = []
    let detail = null
    const genres = GENRE_MAPPINGS + ',Others'
    genres.split(',').map(genre => {
      if (genre === 'Others') {
        detail = details.filter(detail => !detail.genre || (detail.genre && (GENRE_MAPPINGS.split(',').flatMap(genre => detail.genre.indexOf(genre) < 0))))
      } else {
        detail = details.filter(detail => detail.genre && detail.genre.indexOf(genre) > -1)
      }
      if (detail && detail.length > 0)
      {
        detail.map(e => {
          genreList.push({
            'genre': genre,
            'score': e.score ? e.score : 0
            })
        })
      } else {
        genreList.push({
          'genre': genre,
          'score': 0
          })
      }
    })
    let totalVolume = genreList.reduce((total, gen) => total + gen.score, 0)
    let genreListByScore = _(genreList)
    .groupBy('genre')
    .map((g, genre) => ({genre, value: _.sumBy(g, 'score'), percentage: (_.sumBy(g, 'score') / totalVolume) * 100})).orderBy('score', 'desc')
    .value()
    genreListByScore.pop()
    genreListByScore = genreListByScore.filter(n => n.percentage >= 0.1).sort((a, b) => b.value - a.value)
    this.setState({ genreList: genreListByScore})
  }

  render () {
    const { classes, selectedGenres } = this. props
    const { genreList } = this.state

    const charLength = this.props.screenWidth < 375 ? 10 : this.props.screenWidth >= 375 && this.props.screenWidth < 479.95 ? 20
    : this.props.screenWidth >= 480 && this.props.screenWidth < 767.98 ? 50
    : this.props.screenWidth >= 768 && this.props.screenWidth < 1023.98 ? 40
    : this.props.screenWidth >= 1024 && this.props.screenWidth < 1199.98 ? 30
    : this.props.screenWidth >= 1200 && this.props.screenWidth < 1439.98 ? 20
    : (this.props.screenWidth >= 1440)
    ? 30 : 30

    const handleChangePage = (event, page) => {
      this.setState({page: page})
    }

    const titleWithTooltip = (title) => {
      if (title && title.length > charLength) {
        const tooltip = <Tooltip id="tooltip">{title}</Tooltip>
        return (
          <OverlayTrigger overlay={tooltip} placement='top'>
            <span className="txt">{title.substring(0, charLength)}...</span>
          </OverlayTrigger>
        )
      }
      return (<span>{title}</span>)
    }

    return (
      <Paper className={`metricBox ${classes.paper}`}>
        <Grid container spacing={1} direction="column">
          <Grid item className='cardPadding p-b-0'>
            <span className={`metricTitle ${classes.cardTitle}`}>Top genres by engagement</span>
            <OverlayTrigger overlay={<Tooltip id="tooltip">{'Top genres by engagement'}</Tooltip>} placement="right">
              <img className={classes.cardInfo} src="/static/images/info.png" alt="info"/>
            </OverlayTrigger>
          </Grid>
        </Grid>
        { genreList &&
          genreList.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((row, index) => (
            <Box className={`${index === 0 && 'boxStart'} primary`} key={index}>
              <Box className={`${selectedGenres.filter(e => e === row.genre).length > 0 ? 'selected-genre' : ''} d-flex align-items-center cursorPointer topEngagementFilter`} onClick={() => this.props.setSelectedGenres(row.genre)}>
                <Box className="w-30">
                  <Typography className="metricProLabel cardThree">{titleWithTooltip(row.genre)}</Typography>
                </Box>
                <Box className="w-40 progressRotate">
                  <BorderLinearProgressPrimary variant="determinate" value={row.percentage ? row.percentage : 0} />
                </Box>
                <Box className="w-30 text-right">
                  <Typography className="metricProLabel cardThree">{TableFormats.trackerFormatKM(row.value)} ({row.percentage && row.percentage >= 1 ? Math.round(row.percentage * 10) / 10 : row.percentage ? Math.round(row.percentage * 100) / 100 : 0}%)</Typography>
                </Box>
              </Box>
              { index !== 2 &&
                <Divider className="progressDivide"/>
              }
            </Box>
          ))
        }
        <Table className='tableFooter'>
          <TableBody>
            <TableRow>
              <TablePagination
                rowsPerPageOptions= {[3, 6, 9]}
                count={genreList ? genreList.length : 3}
                rowsPerPage={3}
                page={this.state.page}
                onChangePage={handleChangePage}
                labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} of ${count !== -1 ? count : `more than ${to}}`} results`}
              />
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    )
  }
}

export default withStyles(styles)(GlobalAttentionGenreComponent)
